// extracted by mini-css-extract-plugin
export default {"link":"uN-z","disabled":"vN-z"};